import { common } from "../locales/en/translation.json";

export const APP_GLOBAL_VARIABLES = {
  app_author: "Kévin Painchaud",
  app_baseline: common.app_baseline,
  app_description: common.app_description,
  app_domain: "campee.app",
  app_email: "hello@campee.app",
  app_name: "Campee",
  app_url: "https://www.campee.app",
};
